import { isAxiosError } from 'axios';

import { httpPOST } from './http';

export const LANDING_SIGNUP_URL = 'https://taman.tech/signup';
export const PRIVACY_POLICY_URL = 'https://taman.tech/privacy-policy';

/** Public reCAPTCHA site key from env-config.js; the same key the landing page signup uses. */
export const captchaSiteKey = (): string => String(window._env_?.VITE_CAPTCHA_SITE_KEY ?? '');

/** In-app early access signup needs a captcha key, else we link to the landing page (e.g. locally). */
export const isInAppEarlyAccessEnabled = (): boolean => captchaSiteKey() !== '';

interface WaitlistRequest {
  email: string;
  profession: string;
  subscribedToNewsletter: boolean;
  captchaToken: string;
}

/** Joins the early access waitlist. Resolves to `'already'` when the email was on the list before. */
export const joinWaitlist = async (request: WaitlistRequest): Promise<'added' | 'already'> => {
  try {
    await httpPOST('/waitlist', request);
    return 'added';
  } catch (e) {
    if (isAxiosError(e) && e.response?.status === 400 && /already exists/i.test(String(e.response.data))) {
      return 'already';
    }
    throw e;
  }
};
